import dashboard6APIsService from "../dashboard6APIs";
import { createDataHook } from "../../helpers/util";
import { GOOGLE_CHARTS_TYPES } from "../../consts/graphs";

const useFetchDashboard6Data = createDataHook(
  dashboard6APIsService,
  (filters, params, controller, apiService = dashboard6APIsService) => ({
    fetchSummaryCardsData: () =>
      apiService.fetchSummaryCardsData(filters, controller.signal),
    fetchPercentageOfCreditsUsedAvailableByOrganisationData: () =>
      apiService.fetchPercentageOfCreditsUsedAvailableByOrganisationData(
        { ...params, cartType: GOOGLE_CHARTS_TYPES.BARCHART, limit: 10 },
        controller.signal
      ),
    fetchOrganisationsWithoutCreditsData: () =>
      apiService.fetchOrganisationsWithoutCreditsData(
        { ...params, orgsWithCredits: false, sortBy: "name", sortOrder: "asc" },
        controller.signal
      ),
    fetchOrganisationWithUsersAndCreditDetailsData: () =>
      apiService.fetchOrganisationWithUsersAndCreditDetailsData(
        { ...params },
        controller.signal
      ),
    fetchCreditReportData: () =>
      apiService.fetchCreditReportData(
        { ...params, chartType: GOOGLE_CHARTS_TYPES.TABLE },
        controller.signal
      ),
  }),
  { preflight: "shared" }
);

export default useFetchDashboard6Data;
